import $x from '@/utils/$x';

export async function getUserAuth(params) {
  return $x.get(`/user/auth`, params);
}

// 侧边栏-约课
export async function appointClass(params) {
  return $x.post(`/sidebar/appointClass`, params);
}
// 侧边栏-修改约课
export async function changeAppointment(params) {
  return $x.post(`/sidebar/changeAppointment`, params);
}
// 侧边栏-生成训练计划
export async function generalHealthPlanByTarget(params) {
  return $x.get(`/sidebar/generalHealthPlanByTarget`, params);
}
// 侧边栏-计划基础信息模块
export async function getReportInfo(params) {
  return $x.post(`/sidebar/getReportInfo`, params);
}
// 侧边栏-报告计划模块
export async function getUserFitnessReportList(params) {
  return $x.post(`/sidebar/getUserFitnessReportList`, params);
}
// 侧边栏-获取用户体测报告详情信息
export async function getUserFitnessReportDetail(params) {
  return $x.post(`/sidebar/getUserFitnessReportDetail`, params);
}
// 侧边栏-获取用户信息
export async function getUserInfo(params) {
  return $x.post(`/sidebar/getUserInfo`, params);
}
// 侧边栏-获取用户训练计划履约信息
export async function getWeekPerformList(params) {
  return $x.post(`/sidebar/getWeekPerformList`, params);
}
// 侧边栏-获取用户训练计划某一周课程信息
export async function getWeeklyCoursesByWeekNo(params) {
  return $x.post(`/sidebar/getWeeklyCoursesByWeekNo`, params);
}

// 侧边栏-获取用户训练计划某一周课程信息
export async function queryPromotionList(params) {
  return $x.post(`/sidebar/queryPromotionList`, params);
}

// 侧边栏-生成用户体测报告信息
export async function saveReportInfo(params) {
  return $x.post(`/sidebar/saveReportInfo`, params);
}

// 侧边栏-发送体测报告， 推广页
export async function sendMiniLink(params) {
  return $x.post(`/common/getConfigType`, params);
}

// 侧边栏-获取体测课/正式课
export async function getCourse(params) {
  return $x.post(`/sidebar/getCourse`, params);
}

//
export async function queryOnlineCoachList(params) {
  return $x.post(`/sidebar/queryOnlineCoachList`, params);
}
// 获取用户最新体测报告
export async function getUserNewestFitnessReportResponse(params) {
  return $x.post(`/sidebar/getUserNewestFitnessReportResponse`, params);
}

// 编辑 身高体重
export async function saveQuestionnaireInfo(params) {
  return $x.post(`/sidebar/saveQuestionnaireInfo`, params);
}
